import React from "react";

import { localize } from "../../../services/localize";

import SettingsElement from "../../../ui-components/settings-element/settings-element";
import EnvironmentDisplay from "../../../ui-components/environment-display/environment-display";
import VersionDisplay from "../../../ui-components/version-display/version-display";

import { fetchAuthenticationLogout } from "../../../services/api-raindrop";
import { useNavigate } from "react-router-dom";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";
import { Size } from "../../../logic/enums.ts";

const SettingsList = ({ onLogoutRaindrop, accountId }) => {
  const navigate = useNavigate();

  const onLogout = () => {
    fetchAuthenticationLogout({ application: "raindrop" })
      .then((data) => {
        onLogoutRaindrop();
        navigate("/raindrop/entry");
      })
      .catch((error) => {
        console.error("🔴 (RD-697) - ", error);
      });
  };

  const isAnonymous = accountId == null;

  return (
    <div className="flex flex-col gap-4 w-full h-full overflow-y-auto no-scrollbar px-4 py-6">
      {isAnonymous && (
        <RaindropCard>
          <div className="flex flex-col gap-6 w-full h-full">
            <RaindropHeading title="You're not logged in" emoji="" />
            <p className="text-color-dark-text-secondary text-left">
              Log in or sign up to access all features.
            </p>

            <div className="flex flex-row gap-2 w-full">
              <RaindropButton
                title="Login"
                to={"/raindrop/login"}
                size={Size.Large}
                isFluid={true}
              />
              <RaindropButton
                title="Sign Up"
                to={"/raindrop/sign-up"}
                style={ButtonStyle.Primary}
                size={Size.Large}
                isFluid={true}
              />
            </div>
          </div>
        </RaindropCard>
      )}

      <RaindropCard>
        <RaindropHeading title="Your giving" style={ButtonStyle.Secondary} />

        <SettingsElement
          id={"settings-element-contributions"}
          title={"Contributions"}
          to={"/raindrop/settings/contributions"}
          isClickable={true}
          icon={"fa fa-droplet"}
          isLocked={isAnonymous}
        />
        <SettingsElement
          id={"settings-element-payment-method-add"}
          title={localize("COPY_PAYMENT_METHOD_ADD")}
          to={"/raindrop/settings/payment-methods"}
          isClickable={true}
          icon={"fa fa-credit-card"}
          isLocked={isAnonymous}
        />
      </RaindropCard>

      <RaindropCard>
        <RaindropHeading
          title="Support Raindrop"
          style={ButtonStyle.Secondary}
        />

        <SettingsElement
          title={"How can we improve?"}
          icon={"fa fa-comment"}
          to={"/raindrop/feedback"}
          isClickable={true}
          isLocked={isAnonymous}
        />
        <SettingsElement
          id={"settings-element-coffee"}
          title={"Buy us a coffee"}
          to={"/raindrop/buy-coffee"}
          isClickable={true}
          icon={"fa fa-coffee"}
          isLocked={isAnonymous}
        />
        <SettingsElement
          id={"settings-add-to-home-screen"}
          to={"/raindrop/tip-add-to-home"}
          title={"Add to Home Screen"}
          isClickable={true}
          icon={"fa fa-square-plus"}
        />
        <SettingsElement
          id={"settings-element-contributions"}
          title={"Frequently Asked Questions"}
          to={`/raindrop/settings/frequently-asked-questions`}
          isClickable={true}
          icon={"fa fa-question-circle"}
        />
        <SettingsElement
          title={"Take the tour"}
          icon={"fa fa-play"}
          to={"/raindrop/tour"}
          isClickable={true}
        />
      </RaindropCard>

      <RaindropCard>
        <RaindropHeading
          title="General Settings"
          style={ButtonStyle.Secondary}
        />

        <SettingsElement
          title={"Notifications"}
          to={"/raindrop/settings/notifications"}
          isClickable={true}
          icon={"fa fa-bell"}
          isLocked={isAnonymous}
        />

        <SettingsElement
          title={"Setup a password"}
          icon={"fa fa-lock"}
          to={"/raindrop/password-reset"}
          isClickable={true}
          isLocked={isAnonymous}
        />

        <SettingsElement
          title={"Logout"}
          icon={"fa fa-right-from-bracket"}
          onClick={onLogout}
          isLocked={isAnonymous}
        />
      </RaindropCard>

      <div
        className={
          "flex flex-row w-full items-center justify-between gap-1 py-4"
        }
      >
        <VersionDisplay />
        <EnvironmentDisplay />
      </div>
    </div>
  );
};

const RaindropSettings = ({
  userCurrent,
  setUserCurrent,
  onLogoutRaindrop,
}) => {
  return (
    <div className={"flex flex-col h-full gap-4 overflow-visible w-full px-2"}>
      <SettingsList
        userNamePreferred={userCurrent?.namePreferred}
        onLogoutRaindrop={onLogoutRaindrop}
        accountId={userCurrent?.account.id}
      />
    </div>
  );
};

export default RaindropSettings;
